import { LinearProgress } from '@mui/material'
import { BlocksCardLayout } from './BlocksCardLayout'

export function BlocksCardSkeleton() {
  return <BlocksCardLayout content={<LinearProgress />}></BlocksCardLayout>
}
